import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class Payment {
  @Expose()
  @IsNumber()
  amountInCurrency!: number;

  @Expose()
  @IsString()
  formOfPaymentName!: string;

  @Expose()
  @IsString()
  paymentDate!: string;
}

export class DocumentWithPayments {
  @Expose()
  @IsString()
  documentNumber!: string;

  @Expose()
  @IsString()
  currency!: string;

  @Expose()
  @IsNumber()
  grossInCurrency!: number;

  @Expose()
  @IsNumber()
  sumPaymentAmountInCurrency!: number;

  @Expose()
  @IsNumber()
  amountLeftInCurrency!: number;

  @Expose()
  @IsArray()
  @Type(() => Payment)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  settlements!: Array<Payment>;
}

export class DocumentsWithPaymentsResponse extends GenericTableResponse<DocumentWithPayments> {
  @Expose()
  @IsArray()
  @Type(() => DocumentWithPayments)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<DocumentWithPayments>;

  @Expose()
  @IsString()
  @IsOptional()
  leftToPay!: null | string;
}
